import React from "react";
import { mediaSrc } from "@/lib/api";

/**
 * Full-bleed background media. Renders an autoplaying muted looped <video>
 * when videoUrl is present, otherwise a cover <img>. Sits absolutely inside a
 * relatively-positioned, overflow-hidden parent.
 */
export default function BackgroundMedia({ videoUrl, imageUrl, posterUrl, testId, className = "" }) {
  const vid = videoUrl ? mediaSrc(videoUrl) : "";
  const img = imageUrl ? mediaSrc(imageUrl) : "";
  const poster = posterUrl ? mediaSrc(posterUrl) : img;

  if (vid) {
    return (
      <video
        data-testid={testId}
        className={`absolute inset-0 w-full h-full object-cover ${className}`}
        src={vid}
        poster={poster || undefined}
        autoPlay
        muted
        loop
        playsInline
      />
    );
  }
  return (
    <div
      data-testid={testId}
      className={`absolute inset-0 w-full h-full bg-lux-line bg-center bg-cover ${className}`}
      style={img ? { backgroundImage: `url("${img}")` } : undefined}
    />
  );
}
